module.exports = __webpack_public_path__ + "img/covomo.279c59f7.png";